import { render, staticRenderFns } from "./hotModels.vue?vue&type=template&id=0b2d7dab&scoped=true&"
import script from "./hotModels.vue?vue&type=script&lang=js&"
export * from "./hotModels.vue?vue&type=script&lang=js&"
import style0 from "./hotModels.vue?vue&type=style&index=0&id=0b2d7dab&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2d7dab",
  null
  
)

export default component.exports